import type * as GraphQLTypes from '../../../graphql/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DeletePackageHotelMutationVariables = GraphQLTypes.Exact<{
  packageId: GraphQLTypes.Scalars['String'];
  hotelId: GraphQLTypes.Scalars['String'];
}>;


export type DeletePackageHotelMutationResult = (
  { __typename?: 'Mutation' }
  & Pick<GraphQLTypes.Mutation, 'deletePackageHotel'>
);


export const DeletePackageHotelDocument = /*#__PURE__*/ gql`
    mutation deletePackageHotel($packageId: String!, $hotelId: String!) {
  deletePackageHotel(packageId: $packageId, hotelId: $hotelId)
}
    `;

/**
 * __useDeletePackageHotelMutation__
 *
 * To run a mutation, you first call `useDeletePackageHotelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePackageHotelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePackageHotelMutation, { data, loading, error }] = useDeletePackageHotelMutation({
 *   variables: {
 *      packageId: // value for 'packageId'
 *      hotelId: // value for 'hotelId'
 *   },
 * });
 */
export function useDeletePackageHotelMutation(baseOptions?: Apollo.MutationHookOptions<DeletePackageHotelMutationResult, DeletePackageHotelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePackageHotelMutationResult, DeletePackageHotelMutationVariables>(DeletePackageHotelDocument, options);
      }
export type DeletePackageHotelMutationHookResult = ReturnType<typeof useDeletePackageHotelMutation>;